document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
  }

  document.querySelectorAll('video[autoplay]').forEach((video) => {
    video.muted = true;
    video.play().catch(() => {});
  });

  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('.hero-cinematic__slide')];
    const dots = [...carousel.querySelectorAll('[data-hero-slide]')];
    let current = 0;
    let timer;

    const showSlide = (index) => {
      current = index;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === current));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const restart = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => showSlide((current + 1) % slides.length), 6500);
    };

    dots.forEach((dot) => dot.addEventListener('click', () => {
      showSlide(Number(dot.dataset.heroSlide));
      restart();
    }));
    restart();
  });
});
